import React from "react"
import { styled } from "themes"
import { Drawer } from "antd"

export const StyledDrawer = styled((props: any) => <Drawer {...props} />)``
